module.exports = __webpack_public_path__ + "static/back_gradient-6330a7c7f0c1520e07efef7cdf740b34.png";